import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=bc96e45c&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=bc96e45c&prod&lang=scss&scoped=true"
import style1 from "./LandingPage.vue?vue&type=style&index=1&id=bc96e45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc96e45c",
  null
  
)

export default component.exports